module.exports = __webpack_public_path__ + "static/media/suit_below_img2.76a10685.png";